import React, {useState} from 'react';
import {
  Box, CircularProgress,
  Divider,
  Stack,
} from '@mui/material';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import {Question} from "../../models/Question";
import {SecondaryIconButton} from "../button/ButtonVariants";
import {TextFieldChat} from "../textField/TextFieldChat";
import {Person, SmartToy} from "@mui/icons-material";
import theme from "../../theme/theme";
import Typography from "@mui/material/Typography";

interface QAProps {
  questions: Question[];
  currentQuestion: string;
  onChangeQuestion: (val: string) => void;
  onSend: () => void;
  isWaitingForResponse: boolean;
}

export const AgentPreview: React.FC<QAProps> = (
    {
      questions,
      currentQuestion,
      onChangeQuestion,
      onSend,
      isWaitingForResponse,
    }) => {

  const handleSubmit = (event?: React.FormEvent<HTMLFormElement>) => {
    event?.preventDefault();
    onSend();
    onChangeQuestion('');
  };

  return (
      <Box
          sx={{
            position: 'relative',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
      >
        <Typography
            variant="h6"
            align="center"
            bgcolor={theme.palette.custom.customBackgroundGray}
            p={2}
        >
          Vorschau
        </Typography>

        <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              bgcolor: theme.palette.custom.customBackgroundGray,
              pb: '120px',
            }}
        >
          <Stack spacing={2} sx={{p: 2}}>
            {questions.map((q, index) => (
                <React.Fragment key={index}>
                  <TextFieldChat
                      readOnly
                      fullWidth
                      value={q.question}
                      startIcon={<Person color="secondary" fontSize="large"/>}
                  />
                  <TextFieldChat
                      readOnly
                      fullWidth
                      value={q.answer}
                      startIcon={<SmartToy color="secondary" fontSize="large"/>}
                  />
                  {index < questions.length - 1 && <Divider/>}
                </React.Fragment>
            ))}
          </Stack>
        </Box>

        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              position: 'absolute',
              bottom: 48,
              left: 0,
              right: 0,
              px: 10,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              zIndex: theme.zIndex.appBar + 1,
            }}
        >
          <TextFieldChat
              fullWidth
              placeholder="Stelle eine Frage..."
              value={currentQuestion}
              onChange={(e) => onChangeQuestion(e.target.value)}
              onEnterPress={handleSubmit}
              endButton={
                <SecondaryIconButton
                    aria-label="senden"
                    size="large"
                    disabled={!currentQuestion.trim()}
                    type="submit"
                >
                  {isWaitingForResponse? (
                      <CircularProgress
                          size={20}
                          sx={{ color: 'white' }}
                      />
                  ) : (
                      <ArrowUpward sx={{ width: 18, height: 18, color: 'white' }} />
                  )}
                </SecondaryIconButton>
              }
              sx={{
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.5)',
              }}
          />
        </Box>
      </Box>
  );
};